import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../graphql-types'

const defaultOptions = {} as const
export type OraclePersonalityListQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  order?: Types.InputMaybe<Array<Array<Types.Scalars['String']> | Types.Scalars['String']> | Array<Types.Scalars['String']> | Types.Scalars['String']>;
  where?: Types.InputMaybe<Types.OraclePersonalityListWhere>;
}>;

export type OraclePersonalityListQuery = { __typename?: 'Query', oraclePersonalityList: { __typename?: 'OraclePersonalityListResponse', oraclePersonalities: Array<{ __typename?: 'OraclePersonality', id: string, key: string }> } };

export type OraclePersonalityListByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;

export type OraclePersonalityListByIdQuery = { __typename?: 'Query', oraclePersonalityList: { __typename?: 'OraclePersonalityListResponse', oraclePersonalities: Array<{ __typename?: 'OraclePersonality', id: string, key: string }> } };

export type StartNewChatMutationVariables = Types.Exact<{
  personalityId: Types.Scalars['ID'];
  message: Types.Scalars['String'];
  mode?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type StartNewChatMutation = { __typename?: 'Mutation', oracleAgentChat: { __typename?: 'OracleAgentChatPayload', chatSessionId?: string | null, text: string, executionTime: number, error?: string | null, success: boolean, errors: Array<string> } };

export type ContinueChatMutationVariables = Types.Exact<{
  chatSessionId: Types.Scalars['ID'];
  personalityId: Types.Scalars['ID'];
  message: Types.Scalars['String'];
  mode?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type ContinueChatMutation = { __typename?: 'Mutation', oracleAgentChat: { __typename?: 'OracleAgentChatPayload', chatSessionId?: string | null, text: string, executionTime: number, error?: string | null, success: boolean, errors: Array<string> } };

export type GetChatMessagesQueryVariables = Types.Exact<{
  chatSessionId: Types.Scalars['ID'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  order?: Types.InputMaybe<Array<Array<Types.Scalars['String']> | Types.Scalars['String']> | Array<Types.Scalars['String']> | Types.Scalars['String']>;
  language?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type GetChatMessagesQuery = { __typename?: 'Query', oracleMessagePairList: { __typename?: 'OracleMessagePairListResponse', oracleMessagePairs: Array<{ __typename?: 'OracleMessagePair', id: string, thumbsValue: string, createdAt: string, mode: string, userMessage: { __typename?: 'OracleMessage', role: string, content: string }, oracleMessage: { __typename?: 'OracleMessage', content: string, role: string }, documents: Array<{ __typename?: 'OracleDocument', documentsId: string, componentId: string, componentType: string, contentType: string, title: string, contentLink?: { __typename?: 'ContentLinkDocument', contentType: string, contentId: number, title: string, path: string } | null, content?: { __typename?: 'Content', id?: string | null, contentId?: number | null, path?: string | null, title?: string | null, contentType?: string | null, contentAssetReferences?: Array<{ __typename?: 'ContentAssetReference', asset?: { __typename?: 'Asset', renderUrl?: string | null, language?: string | null } | null } | null> | null, featureMedia?: { __typename?: 'Media', mediaId?: string | null, mediaAssets?: Array<{ __typename?: 'MediaAsset', language?: string | null } | null> | null } | null, contentSeries?: Array<{ __typename?: 'Content', id?: string | null, contentId?: number | null, title?: string | null } | null> | null } | null, oracle?: { __typename?: 'OracleCardDocument', readingId: string, pullId: string, collectionId?: string | null, collectionKey?: string | null, backImageUrl?: string | null, objects: Array<{ __typename?: 'OracleDocumentObject', position: string, objectId: string, objectKey?: string | null, displayName?: string | null, invite: string, insight: string, frontImageUrl?: string | null }> } | null, tarot?: { __typename?: 'TarotDocument', readingId: string, pullId: string, pulledAt?: string | null, collectionId?: string | null, collectionKey?: string | null, spread?: string | null, backImageUrl?: string | null, objects: Array<{ __typename?: 'TarotDocumentObject', position: string, objectId: string, objectKey?: string | null, displayName?: string | null, reversed?: boolean | null, frontImageUrl?: string | null }> } | null }> }> } };

export type GetHistoryQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  favorite?: Types.InputMaybe<Types.Scalars['Boolean']>;
  order?: Types.InputMaybe<Array<Array<Types.Scalars['String']> | Types.Scalars['String']> | Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;

export type GetHistoryQuery = { __typename?: 'Query', oracleChatSessionList: { __typename?: 'OracleChatSessionListResponse', limit: number, offset: number, oracleChatSessions: Array<{ __typename?: 'OracleChatSession', id: string, name: string, personalityId: string, favorite: boolean, favoriteUpdatedAt?: string | null, updatedAt: string, contentId?: string | null, featureMediaId?: string | null }> } };

export type MemberHomeFirstTouchRecentOracleSessionsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int'];
}>;

export type MemberHomeFirstTouchRecentOracleSessionsQuery = { __typename?: 'Query', oracleChatSessionList: { __typename?: 'OracleChatSessionListResponse', limit: number, offset: number, oracleChatSessions: Array<{ __typename?: 'OracleChatSession', id: string, name: string, personalityId: string, updatedAt: string, contentId?: string | null, featureMediaId?: string | null }> } };

export type GetChatSessionQueryVariables = Types.Exact<{
  chatSessionId: Types.Scalars['ID'];
}>;

export type GetChatSessionQuery = { __typename?: 'Query', oracleChatSession?: { __typename?: 'OracleChatSession', id: string, name: string, personalityId: string, createdAt: string, updatedAt: string, contentId?: string | null, featureMediaId?: string | null, chatChannel: string } | null };

export type SeedQuestionListQueryVariables = Types.Exact<{
  language?: Types.InputMaybe<Types.Scalars['String']>;
  where?: Types.InputMaybe<Types.SeedQuestionListWhere>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type SeedQuestionListQuery = { __typename?: 'Query', seedQuestionList: { __typename?: 'SeedQuestionListResponse', seedQuestions: Array<{ __typename?: 'SeedQuestion', id: string, question: string, tags: Array<string>, language: string }> } };

export type DivinationSeedQuestionListQueryVariables = Types.Exact<{
  feature: Types.SeedQuestionFeature;
  language?: Types.InputMaybe<Types.Scalars['String']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  category?: Types.InputMaybe<Types.SeedQuestionCategory>;
}>;

export type DivinationSeedQuestionListQuery = { __typename?: 'Query', divinationSeedQuestionList: { __typename?: 'SeedQuestionListResponse', seedQuestions: Array<{ __typename?: 'SeedQuestion', id: string, question: string, tags: Array<string>, language: string }> } };

export type AllTarotCategoryQuestionsQueryVariables = Types.Exact<{
  language?: Types.InputMaybe<Types.Scalars['String']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type AllTarotCategoryQuestionsQuery = { __typename?: 'Query', loveRelationships: { __typename?: 'SeedQuestionListResponse', seedQuestions: Array<{ __typename?: 'SeedQuestion', id: string, question: string, tags: Array<string>, language: string }> }, workMoney: { __typename?: 'SeedQuestionListResponse', seedQuestions: Array<{ __typename?: 'SeedQuestion', id: string, question: string, tags: Array<string>, language: string }> }, personalDevelopment: { __typename?: 'SeedQuestionListResponse', seedQuestions: Array<{ __typename?: 'SeedQuestion', id: string, question: string, tags: Array<string>, language: string }> }, general: { __typename?: 'SeedQuestionListResponse', seedQuestions: Array<{ __typename?: 'SeedQuestion', id: string, question: string, tags: Array<string>, language: string }> } };

export type DivinationFeatureStateQueryVariables = Types.Exact<{
  timezone?: Types.InputMaybe<Types.Scalars['String']>;
  tarotChatSessionId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;

export type DivinationFeatureStateQuery = { __typename?: 'Query', divinationFeatureState: { __typename?: 'DivinationFeatureStates', oracleState: { __typename?: 'OracleCardsFeatureState', chatSessionId?: string | null, canPullCard: boolean }, tarotState: { __typename?: 'TarotFeatureState', chatSessionId?: string | null, canPullCard: boolean, isInBadQuestionState: boolean, badQuestionOriginal?: string | null, badQuestionRephrasedQuestions: Array<string> } } };

export type PersonalizedSeedQuestionListQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  language?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type PersonalizedSeedQuestionListQuery = { __typename?: 'Query', userInfoCurrent?: { __typename?: 'UserInfoCurrentResponse', userInfo?: { __typename?: 'UserInfo', seedQuestions: Array<{ __typename?: 'SeedQuestion', id: string, question: string, language: string }> } | null } | null };

export type UpdateMessagePairThumbsMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  input: Types.OracleMessagePairUpdateInput;
}>;

export type UpdateMessagePairThumbsMutation = { __typename?: 'Mutation', oracleMessagePairUpdate: { __typename?: 'OracleMessagePairUpdateResponse', success: boolean, errors: Array<string>, oracleMessagePair?: { __typename?: 'OracleMessagePair', id: string, thumbsValue: string } | null } };

export type OracleAgentChatSubscriptionSubscriptionVariables = Types.Exact<{
  input: Types.OracleAgentChatInput;
  language?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type OracleAgentChatSubscriptionSubscription = { __typename?: 'Subscription', oracleAgentChat: { __typename?: 'OracleAgentChatSubscriptionPayload', chatSessionId?: string | null, chatChannel?: string | null, messagePairId?: string | null, textChunk?: string | null, error?: string | null, success: boolean, sessionTitle?: string | null, isFinal: boolean, documents?: Array<{ __typename?: 'OracleDocument', contentId: number, componentId: string, componentType: string, contentType: string, title: string, path: string, contentLink?: { __typename?: 'ContentLinkDocument', contentType: string, contentId: number, title: string, path: string } | null, content?: { __typename?: 'Content', id?: string | null, contentId?: number | null, path?: string | null, title?: string | null, contentType?: string | null, contentAssetReferences?: Array<{ __typename?: 'ContentAssetReference', asset?: { __typename?: 'Asset', renderUrl?: string | null, language?: string | null } | null } | null> | null, featureMedia?: { __typename?: 'Media', mediaId?: string | null, mediaAssets?: Array<{ __typename?: 'MediaAsset', language?: string | null } | null> | null } | null, contentSeries?: Array<{ __typename?: 'Content', id?: string | null, contentId?: number | null, title?: string | null } | null> | null } | null, oracle?: { __typename?: 'OracleCardDocument', readingId: string, pullId: string, collectionId?: string | null, collectionKey?: string | null, backImageUrl?: string | null, objects: Array<{ __typename?: 'OracleDocumentObject', position: string, objectId: string, objectKey?: string | null, displayName?: string | null, invite: string, insight: string, frontImageUrl?: string | null }> } | null, tarot?: { __typename?: 'TarotDocument', readingId: string, pullId: string, pulledAt?: string | null, collectionId?: string | null, collectionKey?: string | null, spread?: string | null, backImageUrl?: string | null, objects: Array<{ __typename?: 'TarotDocumentObject', position: string, objectId: string, objectKey?: string | null, displayName?: string | null, reversed?: boolean | null, frontImageUrl?: string | null }> } | null }> | null, errorInfo: Array<{ __typename?: 'AppError', code: string, message: string }>, rateLimitStatus?: { __typename?: 'RateLimitInfo', totalInteractions: number, remainingInteractions: number, rateLimited: boolean, limitType?: string | null } | null, clientSignals?: Array<{ __typename?: 'ClientSignal', type: string, payload?: unknown | null }> | null } };

export type DeleteChatSessionMutationVariables = Types.Exact<{
  chatSessionId: Types.Scalars['ID'];
}>;

export type DeleteChatSessionMutation = { __typename?: 'Mutation', oracleChatSessionDelete: { __typename?: 'OracleChatSessionDeleteResponse', success: boolean, errors: Array<string> } };

export type OracleChatSessionFavoriteMutationVariables = Types.Exact<{
  chatSessionId: Types.Scalars['ID'];
  favorite: Types.Scalars['Boolean'];
}>;

export type OracleChatSessionFavoriteMutation = { __typename?: 'Mutation', oracleChatSessionFavorite: { __typename?: 'OracleChatSessionFavoriteResponse', success: boolean, errors: Array<string>, oracleChatSession?: { __typename?: 'OracleChatSession', name: string, favorite: boolean, favoriteUpdatedAt?: string | null } | null } };

export type OracleChatSessionRenameMutationVariables = Types.Exact<{
  input: Types.OracleChatSessionRenameInput;
}>;

export type OracleChatSessionRenameMutation = { __typename?: 'Mutation', oracleChatSessionRename: { __typename?: 'OracleChatSessionRenameResponse', success: boolean, errors: Array<string>, oracleChatSession?: { __typename?: 'OracleChatSession', id: string, name: string, updatedAt: string } | null } };

export type RateLimitStatusQueryVariables = Types.Exact<{
  timezone?: Types.InputMaybe<Types.Scalars['String']>;
  mode?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type RateLimitStatusQuery = { __typename?: 'Query', rateLimitStatus: { __typename?: 'RateLimitInfo', totalInteractions: number, remainingInteractions: number, rateLimited: boolean, limitType?: string | null } };

export type SearchMessagePairsQueryVariables = Types.Exact<{
  query: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type SearchMessagePairsQuery = { __typename?: 'Query', searchMessagePairs: { __typename?: 'ConversationSearchResponse', totalConversations: number, conversations: Array<{ __typename?: 'ConversationSearchResult', conversationId: string, conversationTitle: string, highlightedTitle?: string | null, matchCount: number, matchedMessages: Array<{ __typename?: 'MessagePairSearchResult', messagePairId: string, snippet: string, matchSource: Types.MatchSourceType, messageIndexInConversation: number, searchRank: number, createdAt: string }> }> } };

export type DivinationCollectionsByTypeQueryVariables = Types.Exact<{
  type: Types.Scalars['String'];
}>;

export type DivinationCollectionsByTypeQuery = { __typename?: 'Query', divinationCollectionsByType: Array<{ __typename?: 'DivinationCollection', id: string, collectionKey: string, name: string, type: string, locale?: string | null, backImageUrl?: string | null, metadata?: unknown | null }> };

export type DivinationCollectionByKeyQueryVariables = Types.Exact<{
  type: Types.Scalars['String'];
  collectionKey: Types.Scalars['String'];
}>;

export type DivinationCollectionByKeyQuery = { __typename?: 'Query', divinationCollectionByKey?: { __typename?: 'DivinationCollection', id: string, collectionKey: string, name: string, type: string, locale?: string | null, backImageUrl?: string | null, metadata?: unknown | null } | null };

export type TarotGreetingUserQueryVariables = Types.Exact<{ [key: string]: never; }>;

export type TarotGreetingUserQuery = { __typename?: 'Query', userProfileCurrent?: { __typename?: 'UserProfile', uid: string, displayName?: string | null } | null };

export const OraclePersonalityListDocument = gql`
    query OraclePersonalityList($limit: Int = 5, $offset: Int = 0, $order: [[String!]!] = [["id", "ASC"]], $where: OraclePersonalityListWhere) {
  oraclePersonalityList(
    limit: $limit
    offset: $offset
    order: $order
    where: $where
  ) {
    oraclePersonalities {
      id
      key
    }
  }
}
    `

/**
 * __useOraclePersonalityListQuery__
 *
 * To run a query within a React component, call `useOraclePersonalityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOraclePersonalityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOraclePersonalityListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOraclePersonalityListQuery (baseOptions?: Apollo.QueryHookOptions<OraclePersonalityListQuery, OraclePersonalityListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OraclePersonalityListQuery, OraclePersonalityListQueryVariables>(OraclePersonalityListDocument, options)
}
export function useOraclePersonalityListLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<OraclePersonalityListQuery, OraclePersonalityListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OraclePersonalityListQuery, OraclePersonalityListQueryVariables>(OraclePersonalityListDocument, options)
}
export function useOraclePersonalityListSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OraclePersonalityListQuery, OraclePersonalityListQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<OraclePersonalityListQuery, OraclePersonalityListQueryVariables>(OraclePersonalityListDocument, options)
}
export type OraclePersonalityListQueryHookResult = ReturnType<typeof useOraclePersonalityListQuery>;
export type OraclePersonalityListLazyQueryHookResult = ReturnType<typeof useOraclePersonalityListLazyQuery>;
export type OraclePersonalityListSuspenseQueryHookResult = ReturnType<typeof useOraclePersonalityListSuspenseQuery>;
export type OraclePersonalityListQueryResult = Apollo.QueryResult<OraclePersonalityListQuery, OraclePersonalityListQueryVariables>;
export const OraclePersonalityListByIdDocument = gql`
    query OraclePersonalityListById($id: Int!) {
  oraclePersonalityList(limit: 1, offset: 0, where: {id: {eq: $id}}) {
    oraclePersonalities {
      id
      key
    }
  }
}
    `

/**
 * __useOraclePersonalityListByIdQuery__
 *
 * To run a query within a React component, call `useOraclePersonalityListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOraclePersonalityListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOraclePersonalityListByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOraclePersonalityListByIdQuery (baseOptions: Apollo.QueryHookOptions<OraclePersonalityListByIdQuery, OraclePersonalityListByIdQueryVariables> & ({ variables: OraclePersonalityListByIdQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OraclePersonalityListByIdQuery, OraclePersonalityListByIdQueryVariables>(OraclePersonalityListByIdDocument, options)
}
export function useOraclePersonalityListByIdLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<OraclePersonalityListByIdQuery, OraclePersonalityListByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OraclePersonalityListByIdQuery, OraclePersonalityListByIdQueryVariables>(OraclePersonalityListByIdDocument, options)
}
export function useOraclePersonalityListByIdSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OraclePersonalityListByIdQuery, OraclePersonalityListByIdQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<OraclePersonalityListByIdQuery, OraclePersonalityListByIdQueryVariables>(OraclePersonalityListByIdDocument, options)
}
export type OraclePersonalityListByIdQueryHookResult = ReturnType<typeof useOraclePersonalityListByIdQuery>;
export type OraclePersonalityListByIdLazyQueryHookResult = ReturnType<typeof useOraclePersonalityListByIdLazyQuery>;
export type OraclePersonalityListByIdSuspenseQueryHookResult = ReturnType<typeof useOraclePersonalityListByIdSuspenseQuery>;
export type OraclePersonalityListByIdQueryResult = Apollo.QueryResult<OraclePersonalityListByIdQuery, OraclePersonalityListByIdQueryVariables>;
export const StartNewChatDocument = gql`
    mutation StartNewChat($personalityId: ID!, $message: String!, $mode: String = "text") {
  oracleAgentChat(
    input: {personalityId: $personalityId, message: $message, mode: $mode}
  ) {
    chatSessionId
    text
    executionTime
    error
    success
    errors
  }
}
    `
export type StartNewChatMutationFn = Apollo.MutationFunction<StartNewChatMutation, StartNewChatMutationVariables>;

/**
 * __useStartNewChatMutation__
 *
 * To run a mutation, you first call `useStartNewChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartNewChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startNewChatMutation, { data, loading, error }] = useStartNewChatMutation({
 *   variables: {
 *      personalityId: // value for 'personalityId'
 *      message: // value for 'message'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useStartNewChatMutation (baseOptions?: Apollo.MutationHookOptions<StartNewChatMutation, StartNewChatMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<StartNewChatMutation, StartNewChatMutationVariables>(StartNewChatDocument, options)
}
export type StartNewChatMutationHookResult = ReturnType<typeof useStartNewChatMutation>;
export type StartNewChatMutationResult = Apollo.MutationResult<StartNewChatMutation>;
export type StartNewChatMutationOptions = Apollo.BaseMutationOptions<StartNewChatMutation, StartNewChatMutationVariables>;
export const ContinueChatDocument = gql`
    mutation ContinueChat($chatSessionId: ID!, $personalityId: ID!, $message: String!, $mode: String = "text") {
  oracleAgentChat(
    input: {personalityId: $personalityId, message: $message, chatSessionId: $chatSessionId, longTermMemory: null, mode: $mode}
  ) {
    chatSessionId
    text
    executionTime
    error
    success
    errors
  }
}
    `
export type ContinueChatMutationFn = Apollo.MutationFunction<ContinueChatMutation, ContinueChatMutationVariables>;

/**
 * __useContinueChatMutation__
 *
 * To run a mutation, you first call `useContinueChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueChatMutation, { data, loading, error }] = useContinueChatMutation({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *      personalityId: // value for 'personalityId'
 *      message: // value for 'message'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useContinueChatMutation (baseOptions?: Apollo.MutationHookOptions<ContinueChatMutation, ContinueChatMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ContinueChatMutation, ContinueChatMutationVariables>(ContinueChatDocument, options)
}
export type ContinueChatMutationHookResult = ReturnType<typeof useContinueChatMutation>;
export type ContinueChatMutationResult = Apollo.MutationResult<ContinueChatMutation>;
export type ContinueChatMutationOptions = Apollo.BaseMutationOptions<ContinueChatMutation, ContinueChatMutationVariables>;
export const GetChatMessagesDocument = gql`
    query GetChatMessages($chatSessionId: ID!, $limit: Int = 10, $offset: Int = 0, $order: [[String!]!] = [["createdAt", "ASC"]], $language: String = "en") {
  oracleMessagePairList(
    chatSessionId: $chatSessionId
    useMaster: true
    limit: $limit
    offset: $offset
    order: $order
  ) {
    oracleMessagePairs {
      id
      thumbsValue
      createdAt
      mode
      userMessage {
        role
        content
      }
      oracleMessage {
        content
        role
      }
      documents {
        documentsId
        componentId
        componentType
        contentType
        title
        contentLink {
          contentType
          contentId
          title
          path
        }
        content {
          id
          contentId
          path
          title
          contentType
          contentAssetReferences(contentAssetReferences: [{type: "d6-keyart-with-text"}]) {
            asset {
              renderUrl
              language
            }
          }
          featureMedia {
            mediaId
            mediaAssets {
              language
            }
          }
          contentSeries(language: [$language]) {
            id
            contentId
            title
          }
        }
        oracle {
          readingId
          pullId
          collectionId
          collectionKey
          backImageUrl
          objects {
            position
            objectId
            objectKey
            displayName
            invite
            insight
            frontImageUrl
          }
        }
        tarot {
          readingId
          pullId
          pulledAt
          collectionId
          collectionKey
          spread
          backImageUrl
          objects {
            position
            objectId
            objectKey
            displayName
            reversed
            frontImageUrl
          }
        }
      }
    }
  }
}
    `

/**
 * __useGetChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatMessagesQuery({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order: // value for 'order'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetChatMessagesQuery (baseOptions: Apollo.QueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables> & ({ variables: GetChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options)
}
export function useGetChatMessagesLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options)
}
export function useGetChatMessagesSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatMessagesQuery, GetChatMessagesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetChatMessagesQuery, GetChatMessagesQueryVariables>(GetChatMessagesDocument, options)
}
export type GetChatMessagesQueryHookResult = ReturnType<typeof useGetChatMessagesQuery>;
export type GetChatMessagesLazyQueryHookResult = ReturnType<typeof useGetChatMessagesLazyQuery>;
export type GetChatMessagesSuspenseQueryHookResult = ReturnType<typeof useGetChatMessagesSuspenseQuery>;
export type GetChatMessagesQueryResult = Apollo.QueryResult<GetChatMessagesQuery, GetChatMessagesQueryVariables>;
export const GetHistoryDocument = gql`
    query GetHistory($limit: Int, $offset: Int, $favorite: Boolean, $order: [[String!]!] = [["activityUpdatedAt", "DESC"]]) {
  oracleChatSessionList(
    limit: $limit
    offset: $offset
    useMaster: true
    where: {favorite: {eq: $favorite}}
    order: $order
  ) {
    oracleChatSessions {
      id
      name
      personalityId
      favorite
      favoriteUpdatedAt
      updatedAt
      contentId
      featureMediaId
    }
    limit
    offset
  }
}
    `

/**
 * __useGetHistoryQuery__
 *
 * To run a query within a React component, call `useGetHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      favorite: // value for 'favorite'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetHistoryQuery (baseOptions?: Apollo.QueryHookOptions<GetHistoryQuery, GetHistoryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetHistoryQuery, GetHistoryQueryVariables>(GetHistoryDocument, options)
}
export function useGetHistoryLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<GetHistoryQuery, GetHistoryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetHistoryQuery, GetHistoryQueryVariables>(GetHistoryDocument, options)
}
export function useGetHistorySuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHistoryQuery, GetHistoryQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetHistoryQuery, GetHistoryQueryVariables>(GetHistoryDocument, options)
}
export type GetHistoryQueryHookResult = ReturnType<typeof useGetHistoryQuery>;
export type GetHistoryLazyQueryHookResult = ReturnType<typeof useGetHistoryLazyQuery>;
export type GetHistorySuspenseQueryHookResult = ReturnType<typeof useGetHistorySuspenseQuery>;
export type GetHistoryQueryResult = Apollo.QueryResult<GetHistoryQuery, GetHistoryQueryVariables>;
export const MemberHomeFirstTouchRecentOracleSessionsDocument = gql`
    query MemberHomeFirstTouchRecentOracleSessions($limit: Int!) {
  oracleChatSessionList(
    limit: $limit
    offset: 0
    useMaster: true
    order: [["activityUpdatedAt", "DESC"]]
  ) {
    oracleChatSessions {
      id
      name
      personalityId
      updatedAt
      contentId
      featureMediaId
    }
    limit
    offset
  }
}
    `

/**
 * __useMemberHomeFirstTouchRecentOracleSessionsQuery__
 *
 * To run a query within a React component, call `useMemberHomeFirstTouchRecentOracleSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberHomeFirstTouchRecentOracleSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberHomeFirstTouchRecentOracleSessionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMemberHomeFirstTouchRecentOracleSessionsQuery (baseOptions: Apollo.QueryHookOptions<MemberHomeFirstTouchRecentOracleSessionsQuery, MemberHomeFirstTouchRecentOracleSessionsQueryVariables> & ({ variables: MemberHomeFirstTouchRecentOracleSessionsQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MemberHomeFirstTouchRecentOracleSessionsQuery, MemberHomeFirstTouchRecentOracleSessionsQueryVariables>(MemberHomeFirstTouchRecentOracleSessionsDocument, options)
}
export function useMemberHomeFirstTouchRecentOracleSessionsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<MemberHomeFirstTouchRecentOracleSessionsQuery, MemberHomeFirstTouchRecentOracleSessionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MemberHomeFirstTouchRecentOracleSessionsQuery, MemberHomeFirstTouchRecentOracleSessionsQueryVariables>(MemberHomeFirstTouchRecentOracleSessionsDocument, options)
}
export function useMemberHomeFirstTouchRecentOracleSessionsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberHomeFirstTouchRecentOracleSessionsQuery, MemberHomeFirstTouchRecentOracleSessionsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MemberHomeFirstTouchRecentOracleSessionsQuery, MemberHomeFirstTouchRecentOracleSessionsQueryVariables>(MemberHomeFirstTouchRecentOracleSessionsDocument, options)
}
export type MemberHomeFirstTouchRecentOracleSessionsQueryHookResult = ReturnType<typeof useMemberHomeFirstTouchRecentOracleSessionsQuery>;
export type MemberHomeFirstTouchRecentOracleSessionsLazyQueryHookResult = ReturnType<typeof useMemberHomeFirstTouchRecentOracleSessionsLazyQuery>;
export type MemberHomeFirstTouchRecentOracleSessionsSuspenseQueryHookResult = ReturnType<typeof useMemberHomeFirstTouchRecentOracleSessionsSuspenseQuery>;
export type MemberHomeFirstTouchRecentOracleSessionsQueryResult = Apollo.QueryResult<MemberHomeFirstTouchRecentOracleSessionsQuery, MemberHomeFirstTouchRecentOracleSessionsQueryVariables>;
export const GetChatSessionDocument = gql`
    query GetChatSession($chatSessionId: ID!) {
  oracleChatSession(id: $chatSessionId, useMaster: true) {
    id
    name
    personalityId
    createdAt
    updatedAt
    contentId
    featureMediaId
    chatChannel
  }
}
    `

/**
 * __useGetChatSessionQuery__
 *
 * To run a query within a React component, call `useGetChatSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatSessionQuery({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *   },
 * });
 */
export function useGetChatSessionQuery (baseOptions: Apollo.QueryHookOptions<GetChatSessionQuery, GetChatSessionQueryVariables> & ({ variables: GetChatSessionQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetChatSessionQuery, GetChatSessionQueryVariables>(GetChatSessionDocument, options)
}
export function useGetChatSessionLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<GetChatSessionQuery, GetChatSessionQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetChatSessionQuery, GetChatSessionQueryVariables>(GetChatSessionDocument, options)
}
export function useGetChatSessionSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatSessionQuery, GetChatSessionQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetChatSessionQuery, GetChatSessionQueryVariables>(GetChatSessionDocument, options)
}
export type GetChatSessionQueryHookResult = ReturnType<typeof useGetChatSessionQuery>;
export type GetChatSessionLazyQueryHookResult = ReturnType<typeof useGetChatSessionLazyQuery>;
export type GetChatSessionSuspenseQueryHookResult = ReturnType<typeof useGetChatSessionSuspenseQuery>;
export type GetChatSessionQueryResult = Apollo.QueryResult<GetChatSessionQuery, GetChatSessionQueryVariables>;
export const SeedQuestionListDocument = gql`
    query SeedQuestionList($language: String = "en", $where: SeedQuestionListWhere, $limit: Int = 4) {
  seedQuestionList(limit: $limit, language: $language, where: $where) {
    seedQuestions {
      id
      question
      tags
      language
    }
  }
}
    `

/**
 * __useSeedQuestionListQuery__
 *
 * To run a query within a React component, call `useSeedQuestionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeedQuestionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeedQuestionListQuery({
 *   variables: {
 *      language: // value for 'language'
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSeedQuestionListQuery (baseOptions?: Apollo.QueryHookOptions<SeedQuestionListQuery, SeedQuestionListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SeedQuestionListQuery, SeedQuestionListQueryVariables>(SeedQuestionListDocument, options)
}
export function useSeedQuestionListLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SeedQuestionListQuery, SeedQuestionListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SeedQuestionListQuery, SeedQuestionListQueryVariables>(SeedQuestionListDocument, options)
}
export function useSeedQuestionListSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeedQuestionListQuery, SeedQuestionListQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SeedQuestionListQuery, SeedQuestionListQueryVariables>(SeedQuestionListDocument, options)
}
export type SeedQuestionListQueryHookResult = ReturnType<typeof useSeedQuestionListQuery>;
export type SeedQuestionListLazyQueryHookResult = ReturnType<typeof useSeedQuestionListLazyQuery>;
export type SeedQuestionListSuspenseQueryHookResult = ReturnType<typeof useSeedQuestionListSuspenseQuery>;
export type SeedQuestionListQueryResult = Apollo.QueryResult<SeedQuestionListQuery, SeedQuestionListQueryVariables>;
export const DivinationSeedQuestionListDocument = gql`
    query DivinationSeedQuestionList($feature: SeedQuestionFeature!, $language: String = "en", $limit: Int = 6, $category: SeedQuestionCategory) {
  divinationSeedQuestionList(
    feature: $feature
    limit: $limit
    language: $language
    category: $category
  ) {
    seedQuestions {
      id
      question
      tags
      language
    }
  }
}
    `

/**
 * __useDivinationSeedQuestionListQuery__
 *
 * To run a query within a React component, call `useDivinationSeedQuestionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDivinationSeedQuestionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDivinationSeedQuestionListQuery({
 *   variables: {
 *      feature: // value for 'feature'
 *      language: // value for 'language'
 *      limit: // value for 'limit'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useDivinationSeedQuestionListQuery (baseOptions: Apollo.QueryHookOptions<DivinationSeedQuestionListQuery, DivinationSeedQuestionListQueryVariables> & ({ variables: DivinationSeedQuestionListQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DivinationSeedQuestionListQuery, DivinationSeedQuestionListQueryVariables>(DivinationSeedQuestionListDocument, options)
}
export function useDivinationSeedQuestionListLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<DivinationSeedQuestionListQuery, DivinationSeedQuestionListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DivinationSeedQuestionListQuery, DivinationSeedQuestionListQueryVariables>(DivinationSeedQuestionListDocument, options)
}
export function useDivinationSeedQuestionListSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DivinationSeedQuestionListQuery, DivinationSeedQuestionListQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DivinationSeedQuestionListQuery, DivinationSeedQuestionListQueryVariables>(DivinationSeedQuestionListDocument, options)
}
export type DivinationSeedQuestionListQueryHookResult = ReturnType<typeof useDivinationSeedQuestionListQuery>;
export type DivinationSeedQuestionListLazyQueryHookResult = ReturnType<typeof useDivinationSeedQuestionListLazyQuery>;
export type DivinationSeedQuestionListSuspenseQueryHookResult = ReturnType<typeof useDivinationSeedQuestionListSuspenseQuery>;
export type DivinationSeedQuestionListQueryResult = Apollo.QueryResult<DivinationSeedQuestionListQuery, DivinationSeedQuestionListQueryVariables>;
export const AllTarotCategoryQuestionsDocument = gql`
    query AllTarotCategoryQuestions($language: String = "en", $limit: Int = 4) {
  loveRelationships: divinationSeedQuestionList(
    feature: TAROT
    limit: $limit
    language: $language
    category: LOVE_RELATIONSHIPS
  ) {
    seedQuestions {
      id
      question
      tags
      language
    }
  }
  workMoney: divinationSeedQuestionList(
    feature: TAROT
    limit: $limit
    language: $language
    category: WORK_MONEY
  ) {
    seedQuestions {
      id
      question
      tags
      language
    }
  }
  personalDevelopment: divinationSeedQuestionList(
    feature: TAROT
    limit: $limit
    language: $language
    category: PERSONAL_DEVELOPMENT
  ) {
    seedQuestions {
      id
      question
      tags
      language
    }
  }
  general: divinationSeedQuestionList(
    feature: TAROT
    limit: $limit
    language: $language
    category: GENERAL
  ) {
    seedQuestions {
      id
      question
      tags
      language
    }
  }
}
    `

/**
 * __useAllTarotCategoryQuestionsQuery__
 *
 * To run a query within a React component, call `useAllTarotCategoryQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTarotCategoryQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTarotCategoryQuestionsQuery({
 *   variables: {
 *      language: // value for 'language'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAllTarotCategoryQuestionsQuery (baseOptions?: Apollo.QueryHookOptions<AllTarotCategoryQuestionsQuery, AllTarotCategoryQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AllTarotCategoryQuestionsQuery, AllTarotCategoryQuestionsQueryVariables>(AllTarotCategoryQuestionsDocument, options)
}
export function useAllTarotCategoryQuestionsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<AllTarotCategoryQuestionsQuery, AllTarotCategoryQuestionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AllTarotCategoryQuestionsQuery, AllTarotCategoryQuestionsQueryVariables>(AllTarotCategoryQuestionsDocument, options)
}
export function useAllTarotCategoryQuestionsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTarotCategoryQuestionsQuery, AllTarotCategoryQuestionsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AllTarotCategoryQuestionsQuery, AllTarotCategoryQuestionsQueryVariables>(AllTarotCategoryQuestionsDocument, options)
}
export type AllTarotCategoryQuestionsQueryHookResult = ReturnType<typeof useAllTarotCategoryQuestionsQuery>;
export type AllTarotCategoryQuestionsLazyQueryHookResult = ReturnType<typeof useAllTarotCategoryQuestionsLazyQuery>;
export type AllTarotCategoryQuestionsSuspenseQueryHookResult = ReturnType<typeof useAllTarotCategoryQuestionsSuspenseQuery>;
export type AllTarotCategoryQuestionsQueryResult = Apollo.QueryResult<AllTarotCategoryQuestionsQuery, AllTarotCategoryQuestionsQueryVariables>;
export const DivinationFeatureStateDocument = gql`
    query DivinationFeatureState($timezone: String, $tarotChatSessionId: ID) {
  divinationFeatureState(
    timezone: $timezone
    tarotChatSessionId: $tarotChatSessionId
  ) {
    oracleState {
      chatSessionId
      canPullCard
    }
    tarotState {
      chatSessionId
      canPullCard
      isInBadQuestionState
      badQuestionOriginal
      badQuestionRephrasedQuestions
    }
  }
}
    `

/**
 * __useDivinationFeatureStateQuery__
 *
 * To run a query within a React component, call `useDivinationFeatureStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDivinationFeatureStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDivinationFeatureStateQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *      tarotChatSessionId: // value for 'tarotChatSessionId'
 *   },
 * });
 */
export function useDivinationFeatureStateQuery (baseOptions?: Apollo.QueryHookOptions<DivinationFeatureStateQuery, DivinationFeatureStateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DivinationFeatureStateQuery, DivinationFeatureStateQueryVariables>(DivinationFeatureStateDocument, options)
}
export function useDivinationFeatureStateLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<DivinationFeatureStateQuery, DivinationFeatureStateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DivinationFeatureStateQuery, DivinationFeatureStateQueryVariables>(DivinationFeatureStateDocument, options)
}
export function useDivinationFeatureStateSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DivinationFeatureStateQuery, DivinationFeatureStateQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DivinationFeatureStateQuery, DivinationFeatureStateQueryVariables>(DivinationFeatureStateDocument, options)
}
export type DivinationFeatureStateQueryHookResult = ReturnType<typeof useDivinationFeatureStateQuery>;
export type DivinationFeatureStateLazyQueryHookResult = ReturnType<typeof useDivinationFeatureStateLazyQuery>;
export type DivinationFeatureStateSuspenseQueryHookResult = ReturnType<typeof useDivinationFeatureStateSuspenseQuery>;
export type DivinationFeatureStateQueryResult = Apollo.QueryResult<DivinationFeatureStateQuery, DivinationFeatureStateQueryVariables>;
export const PersonalizedSeedQuestionListDocument = gql`
    query PersonalizedSeedQuestionList($limit: Int, $language: String = "en") {
  userInfoCurrent {
    userInfo {
      seedQuestions(limit: $limit, language: $language) {
        id
        question
        language
      }
    }
  }
}
    `

/**
 * __usePersonalizedSeedQuestionListQuery__
 *
 * To run a query within a React component, call `usePersonalizedSeedQuestionListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalizedSeedQuestionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalizedSeedQuestionListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePersonalizedSeedQuestionListQuery (baseOptions?: Apollo.QueryHookOptions<PersonalizedSeedQuestionListQuery, PersonalizedSeedQuestionListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PersonalizedSeedQuestionListQuery, PersonalizedSeedQuestionListQueryVariables>(PersonalizedSeedQuestionListDocument, options)
}
export function usePersonalizedSeedQuestionListLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<PersonalizedSeedQuestionListQuery, PersonalizedSeedQuestionListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PersonalizedSeedQuestionListQuery, PersonalizedSeedQuestionListQueryVariables>(PersonalizedSeedQuestionListDocument, options)
}
export function usePersonalizedSeedQuestionListSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalizedSeedQuestionListQuery, PersonalizedSeedQuestionListQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PersonalizedSeedQuestionListQuery, PersonalizedSeedQuestionListQueryVariables>(PersonalizedSeedQuestionListDocument, options)
}
export type PersonalizedSeedQuestionListQueryHookResult = ReturnType<typeof usePersonalizedSeedQuestionListQuery>;
export type PersonalizedSeedQuestionListLazyQueryHookResult = ReturnType<typeof usePersonalizedSeedQuestionListLazyQuery>;
export type PersonalizedSeedQuestionListSuspenseQueryHookResult = ReturnType<typeof usePersonalizedSeedQuestionListSuspenseQuery>;
export type PersonalizedSeedQuestionListQueryResult = Apollo.QueryResult<PersonalizedSeedQuestionListQuery, PersonalizedSeedQuestionListQueryVariables>;
export const UpdateMessagePairThumbsDocument = gql`
    mutation UpdateMessagePairThumbs($id: ID!, $input: OracleMessagePairUpdateInput!) {
  oracleMessagePairUpdate(id: $id, input: $input) {
    success
    errors
    oracleMessagePair {
      id
      thumbsValue
    }
  }
}
    `
export type UpdateMessagePairThumbsMutationFn = Apollo.MutationFunction<UpdateMessagePairThumbsMutation, UpdateMessagePairThumbsMutationVariables>;

/**
 * __useUpdateMessagePairThumbsMutation__
 *
 * To run a mutation, you first call `useUpdateMessagePairThumbsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessagePairThumbsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessagePairThumbsMutation, { data, loading, error }] = useUpdateMessagePairThumbsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessagePairThumbsMutation (baseOptions?: Apollo.MutationHookOptions<UpdateMessagePairThumbsMutation, UpdateMessagePairThumbsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateMessagePairThumbsMutation, UpdateMessagePairThumbsMutationVariables>(UpdateMessagePairThumbsDocument, options)
}
export type UpdateMessagePairThumbsMutationHookResult = ReturnType<typeof useUpdateMessagePairThumbsMutation>;
export type UpdateMessagePairThumbsMutationResult = Apollo.MutationResult<UpdateMessagePairThumbsMutation>;
export type UpdateMessagePairThumbsMutationOptions = Apollo.BaseMutationOptions<UpdateMessagePairThumbsMutation, UpdateMessagePairThumbsMutationVariables>;
export const OracleAgentChatSubscriptionDocument = gql`
    subscription OracleAgentChatSubscription($input: OracleAgentChatInput!, $language: String = "en") {
  oracleAgentChat(input: $input) {
    chatSessionId
    chatChannel
    messagePairId
    textChunk
    documents {
      contentId
      componentId
      componentType
      contentType
      contentLink {
        contentType
        contentId
        title
        path
      }
      content {
        id
        contentId
        path
        title
        contentType
        contentAssetReferences(contentAssetReferences: [{type: "d6-keyart-with-text"}]) {
          asset {
            renderUrl
            language
          }
        }
        featureMedia {
          mediaId
          mediaAssets {
            language
          }
        }
        contentSeries(language: [$language]) {
          id
          contentId
          title
        }
      }
      oracle {
        readingId
        pullId
        collectionId
        collectionKey
        backImageUrl
        objects {
          position
          objectId
          objectKey
          displayName
          invite
          insight
          frontImageUrl
        }
      }
      tarot {
        readingId
        pullId
        pulledAt
        collectionId
        collectionKey
        spread
        backImageUrl
        objects {
          position
          objectId
          objectKey
          displayName
          reversed
          frontImageUrl
        }
      }
      title
      path
    }
    error
    success
    errorInfo {
      code
      message
    }
    sessionTitle
    isFinal
    rateLimitStatus {
      totalInteractions
      remainingInteractions
      rateLimited
      limitType
    }
    clientSignals {
      type
      payload
    }
  }
}
    `

/**
 * __useOracleAgentChatSubscriptionSubscription__
 *
 * To run a query within a React component, call `useOracleAgentChatSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOracleAgentChatSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOracleAgentChatSubscriptionSubscription({
 *   variables: {
 *      input: // value for 'input'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useOracleAgentChatSubscriptionSubscription (baseOptions: Apollo.SubscriptionHookOptions<OracleAgentChatSubscriptionSubscription, OracleAgentChatSubscriptionSubscriptionVariables> & ({ variables: OracleAgentChatSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<OracleAgentChatSubscriptionSubscription, OracleAgentChatSubscriptionSubscriptionVariables>(OracleAgentChatSubscriptionDocument, options)
}
export type OracleAgentChatSubscriptionSubscriptionHookResult = ReturnType<typeof useOracleAgentChatSubscriptionSubscription>;
export type OracleAgentChatSubscriptionSubscriptionResult = Apollo.SubscriptionResult<OracleAgentChatSubscriptionSubscription>;
export const DeleteChatSessionDocument = gql`
    mutation DeleteChatSession($chatSessionId: ID!) {
  oracleChatSessionDelete(id: $chatSessionId) {
    success
    errors
  }
}
    `
export type DeleteChatSessionMutationFn = Apollo.MutationFunction<DeleteChatSessionMutation, DeleteChatSessionMutationVariables>;

/**
 * __useDeleteChatSessionMutation__
 *
 * To run a mutation, you first call `useDeleteChatSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatSessionMutation, { data, loading, error }] = useDeleteChatSessionMutation({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *   },
 * });
 */
export function useDeleteChatSessionMutation (baseOptions?: Apollo.MutationHookOptions<DeleteChatSessionMutation, DeleteChatSessionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteChatSessionMutation, DeleteChatSessionMutationVariables>(DeleteChatSessionDocument, options)
}
export type DeleteChatSessionMutationHookResult = ReturnType<typeof useDeleteChatSessionMutation>;
export type DeleteChatSessionMutationResult = Apollo.MutationResult<DeleteChatSessionMutation>;
export type DeleteChatSessionMutationOptions = Apollo.BaseMutationOptions<DeleteChatSessionMutation, DeleteChatSessionMutationVariables>;
export const OracleChatSessionFavoriteDocument = gql`
    mutation OracleChatSessionFavorite($chatSessionId: ID!, $favorite: Boolean!) {
  oracleChatSessionFavorite(input: {id: $chatSessionId, favorite: $favorite}) {
    success
    errors
    oracleChatSession {
      name
      favorite
      favoriteUpdatedAt
    }
  }
}
    `
export type OracleChatSessionFavoriteMutationFn = Apollo.MutationFunction<OracleChatSessionFavoriteMutation, OracleChatSessionFavoriteMutationVariables>;

/**
 * __useOracleChatSessionFavoriteMutation__
 *
 * To run a mutation, you first call `useOracleChatSessionFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleChatSessionFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleChatSessionFavoriteMutation, { data, loading, error }] = useOracleChatSessionFavoriteMutation({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *      favorite: // value for 'favorite'
 *   },
 * });
 */
export function useOracleChatSessionFavoriteMutation (baseOptions?: Apollo.MutationHookOptions<OracleChatSessionFavoriteMutation, OracleChatSessionFavoriteMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OracleChatSessionFavoriteMutation, OracleChatSessionFavoriteMutationVariables>(OracleChatSessionFavoriteDocument, options)
}
export type OracleChatSessionFavoriteMutationHookResult = ReturnType<typeof useOracleChatSessionFavoriteMutation>;
export type OracleChatSessionFavoriteMutationResult = Apollo.MutationResult<OracleChatSessionFavoriteMutation>;
export type OracleChatSessionFavoriteMutationOptions = Apollo.BaseMutationOptions<OracleChatSessionFavoriteMutation, OracleChatSessionFavoriteMutationVariables>;
export const OracleChatSessionRenameDocument = gql`
    mutation OracleChatSessionRename($input: OracleChatSessionRenameInput!) {
  oracleChatSessionRename(input: $input) {
    success
    errors
    oracleChatSession {
      id
      name
      updatedAt
    }
  }
}
    `
export type OracleChatSessionRenameMutationFn = Apollo.MutationFunction<OracleChatSessionRenameMutation, OracleChatSessionRenameMutationVariables>;

/**
 * __useOracleChatSessionRenameMutation__
 *
 * To run a mutation, you first call `useOracleChatSessionRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOracleChatSessionRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oracleChatSessionRenameMutation, { data, loading, error }] = useOracleChatSessionRenameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOracleChatSessionRenameMutation (baseOptions?: Apollo.MutationHookOptions<OracleChatSessionRenameMutation, OracleChatSessionRenameMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OracleChatSessionRenameMutation, OracleChatSessionRenameMutationVariables>(OracleChatSessionRenameDocument, options)
}
export type OracleChatSessionRenameMutationHookResult = ReturnType<typeof useOracleChatSessionRenameMutation>;
export type OracleChatSessionRenameMutationResult = Apollo.MutationResult<OracleChatSessionRenameMutation>;
export type OracleChatSessionRenameMutationOptions = Apollo.BaseMutationOptions<OracleChatSessionRenameMutation, OracleChatSessionRenameMutationVariables>;
export const RateLimitStatusDocument = gql`
    query RateLimitStatus($timezone: String, $mode: String) {
  rateLimitStatus(timezone: $timezone, mode: $mode) {
    totalInteractions
    remainingInteractions
    rateLimited
    limitType
  }
}
    `

/**
 * __useRateLimitStatusQuery__
 *
 * To run a query within a React component, call `useRateLimitStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRateLimitStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRateLimitStatusQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useRateLimitStatusQuery (baseOptions?: Apollo.QueryHookOptions<RateLimitStatusQuery, RateLimitStatusQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RateLimitStatusQuery, RateLimitStatusQueryVariables>(RateLimitStatusDocument, options)
}
export function useRateLimitStatusLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<RateLimitStatusQuery, RateLimitStatusQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RateLimitStatusQuery, RateLimitStatusQueryVariables>(RateLimitStatusDocument, options)
}
export function useRateLimitStatusSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RateLimitStatusQuery, RateLimitStatusQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<RateLimitStatusQuery, RateLimitStatusQueryVariables>(RateLimitStatusDocument, options)
}
export type RateLimitStatusQueryHookResult = ReturnType<typeof useRateLimitStatusQuery>;
export type RateLimitStatusLazyQueryHookResult = ReturnType<typeof useRateLimitStatusLazyQuery>;
export type RateLimitStatusSuspenseQueryHookResult = ReturnType<typeof useRateLimitStatusSuspenseQuery>;
export type RateLimitStatusQueryResult = Apollo.QueryResult<RateLimitStatusQuery, RateLimitStatusQueryVariables>;
export const SearchMessagePairsDocument = gql`
    query SearchMessagePairs($query: String!, $limit: Int = 50, $offset: Int = 0) {
  searchMessagePairs(query: $query, limit: $limit, offset: $offset) {
    conversations {
      conversationId
      conversationTitle
      highlightedTitle
      matchCount
      matchedMessages {
        messagePairId
        snippet
        matchSource
        messageIndexInConversation
        searchRank
        createdAt
      }
    }
    totalConversations
  }
}
    `

/**
 * __useSearchMessagePairsQuery__
 *
 * To run a query within a React component, call `useSearchMessagePairsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMessagePairsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMessagePairsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchMessagePairsQuery (baseOptions: Apollo.QueryHookOptions<SearchMessagePairsQuery, SearchMessagePairsQueryVariables> & ({ variables: SearchMessagePairsQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchMessagePairsQuery, SearchMessagePairsQueryVariables>(SearchMessagePairsDocument, options)
}
export function useSearchMessagePairsLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<SearchMessagePairsQuery, SearchMessagePairsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchMessagePairsQuery, SearchMessagePairsQueryVariables>(SearchMessagePairsDocument, options)
}
export function useSearchMessagePairsSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMessagePairsQuery, SearchMessagePairsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchMessagePairsQuery, SearchMessagePairsQueryVariables>(SearchMessagePairsDocument, options)
}
export type SearchMessagePairsQueryHookResult = ReturnType<typeof useSearchMessagePairsQuery>;
export type SearchMessagePairsLazyQueryHookResult = ReturnType<typeof useSearchMessagePairsLazyQuery>;
export type SearchMessagePairsSuspenseQueryHookResult = ReturnType<typeof useSearchMessagePairsSuspenseQuery>;
export type SearchMessagePairsQueryResult = Apollo.QueryResult<SearchMessagePairsQuery, SearchMessagePairsQueryVariables>;
export const DivinationCollectionsByTypeDocument = gql`
    query DivinationCollectionsByType($type: String!) {
  divinationCollectionsByType(type: $type) {
    id
    collectionKey
    name
    type
    locale
    backImageUrl
    metadata
  }
}
    `

/**
 * __useDivinationCollectionsByTypeQuery__
 *
 * To run a query within a React component, call `useDivinationCollectionsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDivinationCollectionsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDivinationCollectionsByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDivinationCollectionsByTypeQuery (baseOptions: Apollo.QueryHookOptions<DivinationCollectionsByTypeQuery, DivinationCollectionsByTypeQueryVariables> & ({ variables: DivinationCollectionsByTypeQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DivinationCollectionsByTypeQuery, DivinationCollectionsByTypeQueryVariables>(DivinationCollectionsByTypeDocument, options)
}
export function useDivinationCollectionsByTypeLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<DivinationCollectionsByTypeQuery, DivinationCollectionsByTypeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DivinationCollectionsByTypeQuery, DivinationCollectionsByTypeQueryVariables>(DivinationCollectionsByTypeDocument, options)
}
export function useDivinationCollectionsByTypeSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DivinationCollectionsByTypeQuery, DivinationCollectionsByTypeQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DivinationCollectionsByTypeQuery, DivinationCollectionsByTypeQueryVariables>(DivinationCollectionsByTypeDocument, options)
}
export type DivinationCollectionsByTypeQueryHookResult = ReturnType<typeof useDivinationCollectionsByTypeQuery>;
export type DivinationCollectionsByTypeLazyQueryHookResult = ReturnType<typeof useDivinationCollectionsByTypeLazyQuery>;
export type DivinationCollectionsByTypeSuspenseQueryHookResult = ReturnType<typeof useDivinationCollectionsByTypeSuspenseQuery>;
export type DivinationCollectionsByTypeQueryResult = Apollo.QueryResult<DivinationCollectionsByTypeQuery, DivinationCollectionsByTypeQueryVariables>;
export const DivinationCollectionByKeyDocument = gql`
    query DivinationCollectionByKey($type: String!, $collectionKey: String!) {
  divinationCollectionByKey(type: $type, collectionKey: $collectionKey) {
    id
    collectionKey
    name
    type
    locale
    backImageUrl
    metadata
  }
}
    `

/**
 * __useDivinationCollectionByKeyQuery__
 *
 * To run a query within a React component, call `useDivinationCollectionByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDivinationCollectionByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDivinationCollectionByKeyQuery({
 *   variables: {
 *      type: // value for 'type'
 *      collectionKey: // value for 'collectionKey'
 *   },
 * });
 */
export function useDivinationCollectionByKeyQuery (baseOptions: Apollo.QueryHookOptions<DivinationCollectionByKeyQuery, DivinationCollectionByKeyQueryVariables> & ({ variables: DivinationCollectionByKeyQueryVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DivinationCollectionByKeyQuery, DivinationCollectionByKeyQueryVariables>(DivinationCollectionByKeyDocument, options)
}
export function useDivinationCollectionByKeyLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<DivinationCollectionByKeyQuery, DivinationCollectionByKeyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DivinationCollectionByKeyQuery, DivinationCollectionByKeyQueryVariables>(DivinationCollectionByKeyDocument, options)
}
export function useDivinationCollectionByKeySuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DivinationCollectionByKeyQuery, DivinationCollectionByKeyQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DivinationCollectionByKeyQuery, DivinationCollectionByKeyQueryVariables>(DivinationCollectionByKeyDocument, options)
}
export type DivinationCollectionByKeyQueryHookResult = ReturnType<typeof useDivinationCollectionByKeyQuery>;
export type DivinationCollectionByKeyLazyQueryHookResult = ReturnType<typeof useDivinationCollectionByKeyLazyQuery>;
export type DivinationCollectionByKeySuspenseQueryHookResult = ReturnType<typeof useDivinationCollectionByKeySuspenseQuery>;
export type DivinationCollectionByKeyQueryResult = Apollo.QueryResult<DivinationCollectionByKeyQuery, DivinationCollectionByKeyQueryVariables>;
export const TarotGreetingUserDocument = gql`
    query TarotGreetingUser {
  userProfileCurrent {
    uid
    displayName
  }
}
    `

/**
 * __useTarotGreetingUserQuery__
 *
 * To run a query within a React component, call `useTarotGreetingUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTarotGreetingUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTarotGreetingUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useTarotGreetingUserQuery (baseOptions?: Apollo.QueryHookOptions<TarotGreetingUserQuery, TarotGreetingUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TarotGreetingUserQuery, TarotGreetingUserQueryVariables>(TarotGreetingUserDocument, options)
}
export function useTarotGreetingUserLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<TarotGreetingUserQuery, TarotGreetingUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TarotGreetingUserQuery, TarotGreetingUserQueryVariables>(TarotGreetingUserDocument, options)
}
export function useTarotGreetingUserSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TarotGreetingUserQuery, TarotGreetingUserQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<TarotGreetingUserQuery, TarotGreetingUserQueryVariables>(TarotGreetingUserDocument, options)
}
export type TarotGreetingUserQueryHookResult = ReturnType<typeof useTarotGreetingUserQuery>;
export type TarotGreetingUserLazyQueryHookResult = ReturnType<typeof useTarotGreetingUserLazyQuery>;
export type TarotGreetingUserSuspenseQueryHookResult = ReturnType<typeof useTarotGreetingUserSuspenseQuery>;
export type TarotGreetingUserQueryResult = Apollo.QueryResult<TarotGreetingUserQuery, TarotGreetingUserQueryVariables>;
